
export class DemoManager {
    constructor(audioEngine, config, callbacks) {
        this.engine = audioEngine;
        this.config = config;
        this.onTuneStart = callbacks.onTuneStart;
        this.onStopCallback = callbacks.onStop;
        this.onNotePlay = callbacks.onNote;
        
        this.isPlaying = false;
        this.timeoutId = null;
        this.currentNoteIdx = 0;
        this.currentTuneIdx = 0;
        
        this.tunes = [
            {
                name: "Ode to Joy",
                bpm: 120,
                waveform: 'organ',
                gain: 0.6,
                fx: [
                    { id: 'reverb', enabled: true, params: { mix: 0.3, decay: 3.0 } },
                    { id: 'filter', enabled: true, params: { frequency: 2000, Q: 1, type: 0 } }, // Lowpass
                    { id: 'delay', enabled: false, params: { mix: 0 } },
                    { id: 'distortion', enabled: false, params: { mix: 0 } },
                    { id: 'tremolo', enabled: false, params: { mix: 0 } },
                    { id: 'crusher', enabled: false, params: { mix: 0 } },
                    { id: 'fuzz', enabled: false, params: { mix: 0 } }
                ],
                notes: [
                    // E E F G G F E D C C D E E D D
                    { note: 64, dur: 1 }, { note: 64, dur: 1 }, { note: 65, dur: 1 }, { note: 67, dur: 1 },
                    { note: 67, dur: 1 }, { note: 65, dur: 1 }, { note: 64, dur: 1 }, { note: 62, dur: 1 },
                    { note: 60, dur: 1 }, { note: 60, dur: 1 }, { note: 62, dur: 1 }, { note: 64, dur: 1 },
                    { note: 64, dur: 1.5 }, { note: 62, dur: 0.5 }, { note: 62, dur: 2 }
                ]
            },
            {
                name: "Twinkle Star",
                bpm: 100,
                waveform: 'triangle',
                gain: 0.6,
                fx: [
                    { id: 'reverb', enabled: true, params: { mix: 0.5, decay: 5.0 } },
                    { id: 'delay', enabled: true, params: { mix: 0.4, time: 0.5, feedback: 0.4 } },
                    { id: 'filter', enabled: true, params: { frequency: 1500, Q: 5, type: 0 } },
                    { id: 'tremolo', enabled: true, params: { mix: 0.8, rate: 6, depth: 1 } },
                    { id: 'distortion', enabled: false, params: { mix: 0 } },
                    { id: 'crusher', enabled: false, params: { mix: 0 } },
                    { id: 'fuzz', enabled: false, params: { mix: 0 } }
                ],
                notes: [
                    // C C G G A A G
                    { note: 60, dur: 1 }, { note: 60, dur: 1 }, { note: 67, dur: 1 }, { note: 67, dur: 1 },
                    { note: 69, dur: 1 }, { note: 69, dur: 1 }, { note: 67, dur: 2 },
                    // F F E E D D C
                    { note: 65, dur: 1 }, { note: 65, dur: 1 }, { note: 64, dur: 1 }, { note: 64, dur: 1 },
                    { note: 62, dur: 1 }, { note: 62, dur: 1 }, { note: 60, dur: 2 }
                ]
            },
            {
                name: "8-Bit Jump",
                bpm: 150,
                waveform: 'square',
                gain: 0.4,
                fx: [
                    { id: 'crusher', enabled: true, params: { mix: 1.0, bits: 4, rate: 0.2 } },
                    { id: 'reverb', enabled: false, params: { mix: 0 } },
                    { id: 'delay', enabled: false, params: { mix: 0 } },
                    { id: 'filter', enabled: true, params: { frequency: 8000, Q: 1 } },
                    { id: 'distortion', enabled: false, params: { mix: 0 } },
                    { id: 'tremolo', enabled: false, params: { mix: 0 } },
                    { id: 'fuzz', enabled: false, params: { mix: 0 } }
                ],
                notes: [
                    // E5 E5 E5 C5 E5 G5 G4
                    { note: 76, dur: 0.5 }, { note: 76, dur: 0.5 }, { note: 76, dur: 0.5 }, 
                    { note: 0, dur: 0.5 }, // Rest
                    { note: 72, dur: 0.5 }, { note: 76, dur: 0.5 }, 
                    { note: 0, dur: 0.5 }, // Rest
                    { note: 79, dur: 1 }, 
                    { note: 0, dur: 1 }, // Rest
                    { note: 67, dur: 1 }
                ]
            },
            {
                name: "Stranger Synths",
                bpm: 160,
                waveform: 'retro',
                gain: 0.5,
                fx: [
                    { id: 'filter', enabled: true, params: { frequency: 1200, Q: 2, type: 0 } }, // Lowpass
                    { id: 'delay', enabled: true, params: { mix: 0.4, time: 0.18, feedback: 0.3 } }, // Slapback-ish
                    { id: 'distortion', enabled: true, params: { mix: 0.2, drive: 2.0 } }, // Mild drive
                    { id: 'reverb', enabled: true, params: { mix: 0.4, decay: 4.0 } }, // Deep space
                    { id: 'tremolo', enabled: false, params: { mix: 0 } },
                    { id: 'crusher', enabled: false, params: { mix: 0 } },
                    { id: 'fuzz', enabled: false, params: { mix: 0 } }
                ],
                notes: [
                    // C3 E3 G3 B3 C4 B3 G3 E3 (Repeated)
                    { note: 48, dur: 0.5 }, { note: 52, dur: 0.5 }, { note: 55, dur: 0.5 }, { note: 59, dur: 0.5 },
                    { note: 60, dur: 0.5 }, { note: 59, dur: 0.5 }, { note: 55, dur: 0.5 }, { note: 52, dur: 0.5 },
                    // Repeat
                    { note: 48, dur: 0.5 }, { note: 52, dur: 0.5 }, { note: 55, dur: 0.5 }, { note: 59, dur: 0.5 },
                    { note: 60, dur: 0.5 }, { note: 59, dur: 0.5 }, { note: 55, dur: 0.5 }, { note: 52, dur: 0.5 }
                ]
            },
            {
                name: "Seven Nation",
                bpm: 120,
                waveform: 'bass',
                gain: 0.35,
                fx: [
                    { id: 'fuzz', enabled: true, params: { mix: 0.6, fuzz: 30, tone: 0.3 } }, // Heavy Fuzz
                    { id: 'filter', enabled: true, params: { frequency: 800, Q: 1, type: 0 } }, // Muffled
                    { id: 'distortion', enabled: false, params: { mix: 0 } },
                    { id: 'reverb', enabled: false, params: { mix: 0 } },
                    { id: 'delay', enabled: false, params: { mix: 0 } },
                    { id: 'tremolo', enabled: false, params: { mix: 0 } },
                    { id: 'crusher', enabled: false, params: { mix: 0 } }
                ],
                lfo: { enabled: false, target: 'none', params: { rate: 1, depth: 100, waveform: 0 } },
                notes: [
                    // E - E G E D C B
                    { note: 52, dur: 1.5 }, { note: 52, dur: 0.5 }, { note: 55, dur: 0.75 }, 
                    { note: 52, dur: 0.75 }, { note: 50, dur: 0.75 }, { note: 48, dur: 1.5 }, 
                    { note: 47, dur: 2 }
                ]
            },
            {
                name: "WubWub Step",
                bpm: 140,
                waveform: 'sawtooth',
                gain: 0.45,
                fx: [
                    { id: 'filter', enabled: true, params: { frequency: 800, Q: 5, type: 0 } }, // Lowpass base
                    { id: 'distortion', enabled: true, params: { mix: 0.3, drive: 4.0 } }, // Grit
                    { id: 'reverb', enabled: true, params: { mix: 0.2, decay: 1.5 } },
                    { id: 'delay', enabled: false, params: { mix: 0 } },
                    { id: 'tremolo', enabled: false, params: { mix: 0 } },
                    { id: 'crusher', enabled: false, params: { mix: 0 } },
                    { id: 'fuzz', enabled: false, params: { mix: 0 } }
                ],
                lfo: { enabled: true, target: 'filter:frequency', params: { rate: 3, depth: 700, waveform: 0 } }, // Sine LFO on Filter
                notes: [
                    // D2 (Wobble) - D2 (Fast) - F2 - G2
                    { note: 38, dur: 2 }, 
                    { note: 38, dur: 0.5 }, { note: 38, dur: 0.5 }, 
                    { note: 41, dur: 0.5 }, { note: 43, dur: 0.5 },
                    // D2 (Long Wobble)
                    { note: 38, dur: 4 },
                    // Drop / Variation
                    { note: 38, dur: 1 }, { note: 50, dur: 0.5 }, { note: 48, dur: 0.5 },
                    { note: 43, dur: 1 }, { note: 41, dur: 1 },
                    { note: 38, dur: 2 }, { note: 38, dur: 2 }
                ]
            },
            {
                name: "Cyber Punk City",
                bpm: 130,
                waveform: 'dystopia',
                gain: 0.5,
                fx: [
                    { id: 'reverb', enabled: true, params: { mix: 0.6, decay: 4.0 } }, // Large Space
                    { id: 'delay', enabled: true, params: { mix: 0.5, time: 0.35, feedback: 0.5 } }, // Echo
                    { id: 'distortion', enabled: true, params: { mix: 0.3, drive: 3.0 } }, // Dirty
                    { id: 'filter', enabled: true, params: { frequency: 2000, Q: 2, type: 2 } }, // Bandpass
                    { id: 'crusher', enabled: true, params: { mix: 0.6, bits: 3, rate: 0.8 } }, // Digital Artifacts
                    { id: 'tremolo', enabled: false, params: { mix: 0 } },
                    { id: 'fuzz', enabled: false, params: { mix: 0 } }
                ],
                lfo: { enabled: true, target: 'crusher:rate', params: { rate: 4, depth: 0.5, waveform: 2 } }, // Saw LFO on BitRate
                notes: [
                    // D3 (Intro)
                    { note: 50, dur: 2 },
                    // Run: F G G# A
                    { note: 53, dur: 0.5 }, { note: 55, dur: 0.5 }, { note: 56, dur: 0.5 }, { note: 57, dur: 2.5 },
                    // High Melody: C4 A3 G3 F3
                    { note: 60, dur: 1 }, { note: 57, dur: 1 }, { note: 55, dur: 1 }, { note: 53, dur: 1 },
                    // Resolve D3
                    { note: 50, dur: 4 },
                    // Bass Hit D2
                    { note: 38, dur: 2 }
                ]
            },
            {
                name: "Derivative Drift",
                bpm: 110,
                waveform: 'ethereal',
                gain: 0.5,
                fx: [
                    { id: 'reverb', enabled: true, params: { mix: 0.5, decay: 5.0 } },
                    { id: 'delay', enabled: true, params: { mix: 0.4, time: 0.6, feedback: 0.6 } },
                    { id: 'filter', enabled: true, params: { frequency: 1000, Q: 1.5, type: 0 } },
                    { id: 'tremolo', enabled: true, params: { mix: 0.7, rate: 2, depth: 0.8 } },
                    { id: 'distortion', enabled: false, params: { mix: 0 } },
                    { id: 'crusher', enabled: false, params: { mix: 0 } },
                    { id: 'fuzz', enabled: false, params: { mix: 0 } }
                ],
                // Multi-LFO Setup: LFO 0 on Filter, LFO 1 modulating LFO 0's Rate
                lfo: [
                    { index: 0, target: 'filter:frequency', params: { rate: 1, depth: 800, waveform: 0 } }, // Sine LFO on Filter
                    { index: 1, target: 'lfo1:rate', params: { rate: 0.5, depth: 5, waveform: 3 } } // Triangle on LFO 1 Rate
                ],
                notes: [
                    // Long drifting pads
                    { note: 60, dur: 4 }, // C4
                    { note: 67, dur: 4 }, // G4
                    { note: 64, dur: 4 }, // E4
                    { note: 59, dur: 4 }, // B3
                    // Swells
                    { note: 48, dur: 2 }, { note: 60, dur: 2 },
                    { note: 55, dur: 2 }, { note: 62, dur: 2 },
                    // Final chord spread
                    { note: 43, dur: 8 }  // G2
                ]
            }
        ];
    }

    start() {
        if (this.isPlaying) this.stop();
        this.isPlaying = true;
        this.currentTuneIdx = 0;
        this.playTune(0);
        console.log("Demo Started");
        return "Playing Demo...";
    }

    stop() {
        this.isPlaying = false;
        clearTimeout(this.timeoutId);
        this.engine.allNotesOff();
        console.log("Demo Stopped");
        if (this.onStopCallback) {
            this.onStopCallback();
        }
    }

    playTune(index) {
        if (!this.isPlaying) return;
        if (index >= this.tunes.length) {
            index = 0; // Loop back to start
        }
        this.currentTuneIdx = index;
        
        const tune = this.tunes[index];
        console.log(`Playing: ${tune.name}`);
        
        // Apply FX
        this.engine.setWaveform(tune.waveform);
        
        // Configure all FX
        tune.fx.forEach(effect => {
            this.engine.toggleEffect(effect.id, effect.enabled);
             for (const [param, value] of Object.entries(effect.params)) {
                 this.engine.setEffectParam(effect.id, param, value);
             }
        });

        // Configure LFO
        // Reset both first
        this.engine.setLFOTarget(0, 'none');
        this.engine.setLFOTarget(1, 'none');
        
        const waves = ['sine', 'square', 'sawtooth', 'triangle'];

        if (Array.isArray(tune.lfo)) {
             tune.lfo.forEach(lfoConfig => {
                 this.engine.setLFOTarget(lfoConfig.index, lfoConfig.target);
                 for (const [param, value] of Object.entries(lfoConfig.params)) {
                     let val = value;
                     if (param === 'waveform' && typeof value === 'number') {
                         val = waves[value] || 'sine';
                     }
                     this.engine.setLFOParam(lfoConfig.index, param, val);
                 }
             });
        } else if (tune.lfo) {
            // Legacy single LFO support
            this.engine.setLFOTarget(0, tune.lfo.target);
            for (const [param, value] of Object.entries(tune.lfo.params)) {
                let val = value;
                if (param === 'waveform' && typeof value === 'number') {
                    val = waves[value] || 'sine';
                }
                this.engine.setLFOParam(0, param, val);
            }
        }

        // Call UI callback to visually update knobs and buttons
        if (this.onTuneStart) {
            this.onTuneStart(tune);
        }

        this.currentNoteIdx = 0;
        this.scheduleNextNote(tune);
    }

    scheduleNextNote(tune) {
        if (!this.isPlaying) return;
        if (this.currentTuneIdx !== this.tunes.indexOf(tune)) return; // Tune changed

        if (this.currentNoteIdx >= tune.notes.length) {
            // Tune finished, wait a bit then next tune
            this.timeoutId = setTimeout(() => {
                this.playTune(this.currentTuneIdx + 1);
            }, 1000);
            return;
        }

        const noteData = tune.notes[this.currentNoteIdx];
        const beatTime = 60000 / tune.bpm; // ms per beat
        const duration = noteData.dur * beatTime;
        
        // Play Note
        if (noteData.note > 0) {
            const freq = 440 * Math.pow(2, (noteData.note - 69) / 12);
            // Using 'demo' voice ID and per-tune gain
            this.engine.triggerAttack(freq, tune.gain || 0.6, 'demo');
            
            // Visual Feedback: Simulate Human Gesture (Blob/Swipe)
            if (this.onNotePlay && this.config) {
                const baseX = Math.log2(freq / this.config.minFreq) / Math.log2(this.config.maxFreq / this.config.minFreq);
                const baseY = 0.5 + (Math.sin(this.currentNoteIdx) * 0.2);
                
                let step = 0;
                const maxSteps = 5;
                const gestureId = setInterval(() => {
                    if (!this.isPlaying) {
                        clearInterval(gestureId);
                        return;
                    }
                    
                    // Small linear drift to simulate finger settling or sliding
                    // Random direction per note, but consistent for the gesture
                    const driftX = (Math.random() - 0.5) * 0.005; 
                    const driftY = (Math.random() - 0.5) * 0.005;

                    // Emit a tight cluster (blob) at current position
                    // 3 points per step for density
                    for (let p = 0; p < 3; p++) {
                        const blobX = baseX + (step * driftX) + (Math.random() - 0.5) * 0.015;
                        const blobY = baseY + (step * driftY) + (Math.random() - 0.5) * 0.015;
                        
                        this.onNotePlay(
                            Math.max(0, Math.min(1, blobX)), 
                            Math.max(0, Math.min(1, blobY))
                        );
                    }

                    step++;
                    if (step >= maxSteps) clearInterval(gestureId);
                }, 20); // 100ms total duration
            }
            
            // Schedule Release
            setTimeout(() => {
                if(this.isPlaying) this.engine.triggerRelease('demo');
            }, duration * 0.9);
        }

        this.currentNoteIdx++;
        
        this.timeoutId = setTimeout(() => {
            this.scheduleNextNote(tune);
        }, duration);
    }
}
